import { sx } from './designStyles';
import { useGreeting } from './greeting';

/**
 * The greeting line at the top of a role's home (Andrew, 2026-10-19): "Good morning, Ana."
 * by the building's clock, else this browser's. Drawn only where the page is that role's home.
 */
export function HomeGreeting() {
  const hello = useGreeting();
  return (
    <div data-testid="home-greeting" style={sx('flex:0 0 auto;font-size:15px;font-weight:700;letter-spacing:-.012em;line-height:1.25;color:#22272E;min-width:0;')}>
      {`${hello}.`}
    </div>
  );
}
